import {createSliderWithTooltip} from 'rc-slider';
import Slider from 'rc-slider';

export default class SliderWithTooltip extends createSliderWithTooltip(Slider) {}
